import { createFileRoute } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/package-category-import-jobs'
)({
  meta: () => [{ title: MENU.PACKAGE_CATEGORY_IMPORT_HISTORY }]
})
